import { getToken } from '@/utils/auth'
import URL from '@/api/urlTranslator'
import { cache } from '@/utils/cacheManager'

/**
 * Excel导出
 */
export class ExportUtils {
  static TYPE_STRING = 'String'
  static TYPE_INTEGER = 'String'
  static TYPE_FLOAT = 'FLOAT'
  static TYPE_DATE = 'Date'
  static TYPE_BOOLEAN = 'Boolean'
  static BUNDLE_NAME = 'ExportUtils'
  /**
   * 判断对象类型
   * @param obj
   * @return
   */
  static checkType(obj) {
    // var type = TYPE_STRING
    // if (typeof (obj) == "number")
    //   type = TYPE_FLOAT
    // else if (typeof (obj) == "boolean")
    //   type = TYPE_BOOLEAN
    // else if (obj is Date)
    // type = TYPE_DATE
    // return type
  }
  static downloadTemplateFile(fileName, folderName = 'price') {
    // CARGO-44099 String toExoSystem = ConfigDefPsUtil.getConfigDefValue("ToExoSystem", branchId);=zy参数下调整;
    // 本次需求的地方已经进行了cache的初始化避免其他调用未初始化cache，这里加上trycatch
    try {
      if (String(cache.config.get('ToExoSystem')) === 'zy') {
        if (folderName === 'fba') {
          if (fileName === 'ImportOneFbaOrder.xlsx') {
            fileName = 'ImportOneFbaOrderZy.xlsx'
          } else if (fileName === 'ImportOneSeaFbaOrder.xlsx') {
            fileName = 'ImportOneSeaFbaOrderZy.xlsx'
          } else if (fileName === 'ImportOneAirFbaOrder.xlsx') {
            fileName = 'ImportOneAirFbaOrderZy.xlsx'
          } else if (fileName === 'ImportOneRailwayFbaOrder.xlsx') {
            fileName = 'ImportOneRailwayFbaOrderZy.xlsx'
          }
        }
        if (fileName === 'ImportPartnerTemplate.xls') {
          fileName = 'ImportPartnerTemplateZy.xls'
        }
      }
    } catch (error) {
      console.error('downloadTemplateFile error:', error)
    }
    window.open(URL.seaExport.exportExcelTemplate + '?sessionId=' + getToken() + '&fileName=' + fileName + '&fileSubPath=' + folderName)
  }
  // 下载订单导入模板
  static downloadOrderTemplateFile(branchId, lob) {
    window.open(URL.sys.exportOrderTemplate + '?sessionId=' + getToken() + '&branchId=' + branchId + '&lob=' + lob)
  }
  // 导出做箱信息模板
  static downloadTruckExcelTemplate(fileName, truckingInfoUuid) {
    window.open(URL.seaExport.exportTruckExcelData + '?sessionId=' + getToken() + '&fileName=' + fileName + '&truckingInfoUuid=' + truckingInfoUuid)
  }
  // 导出做箱信息模板 (综合物流)
  static downloadIntegratedTruckExcelTemplate(fileName, jobUuid) {
    window.open(URL.booking.integratedJob.exportTruckExcelData + '?sessionId=' + getToken() + '&fileName=' + fileName + '&jobUuid=' + jobUuid)
  }
  static downloadResultTemplateFile(fileName, folderName = 'price') {
    window.open(URL.seaExport.exportExcelTemplate + '?sessionId=' + getToken() + '&fileName=' + fileName + '&fileSubPath=' + folderName)
    // var variables = new URLVariables()
    // variables.data = folderName
    // variables.type = "excelResultTemplate"
    // variables.fileName = fileName
    // variables.sessonId = Session.getInstance().getCurrentSessionId()
    // exportToExcelByURLVariables(variables, fileName, "ExcelService")
  }
  static downloadTextFile(fileName, content, fileType) {
    // var variables: URLVariables = new URLVariables()
    // variables.fileName = fileName
    // variables.content = content
    // variables.fileType = fileType
    // variables.sessonId = Session.getInstance().getCurrentSessionId()
    // exportToExcelByURLVariables(variables, fileName, "ExportTextService")
  }
  static exportExcelADV22(dataProvider, columns, commonFields, commonValues, fileName = null, selectedAll = false) {
    // var state
    // if (dataProvider is IList)
    // {
    //   state = exportExcel2(dataProvider as IList, columns, commonFields, commonValues, fileName, selectedAll)
    // }
    // 	else if (dataProvider is IHierarchicalCollectionView)
    // {
    //   var list = convertHierarchical(dataProvider as HierarchicalCollectionView)
    //   state = list.length == 0 ? 1 : exportExcel2(list, columns, commonFields, commonValues, fileName, selectedAll)
    // }
    // return state
  }
  /**
   * exportType<br>
   * 0:dataGrid显示什么，导出来就是什么<br>
   * 1:导出的数据按照给定的格式和顺序<br>
   * columnNames指定导出的列名<br>
   * splitIndex,-1表示所有数据放在同一个Sheet中<br>
   * >=0,表示数据按照第几个可见的列的分拆，生成多个Sheet
   */
  static exportToExcelJavaForPrice(dataProvider, columns, priceType, currency, fileName, exportType = 0, columnNames = null, splitIndex = -1) {
    // var xml = null
    // if (dataProvider is IList)
    // {
    //   xml = transformGridDataToXML(dataProvider as IList, columns, exportType, columnNames)
    // }
    // 	else if (dataProvider is IHierarchicalCollectionView)
    // {
    //   var list = convertHierarchical(dataProvider as HierarchicalCollectionView)
    //   xml = transformGridDataToXML(list, columns, exportType, columnNames)
    // }
    // if (xml.children().length() == 1) {
    //   return list != null ? 1 : 2
    // }
    // else {
    //   var variables: URLVariables = new URLVariables()
    //   variables.type = priceType/*PriceFcl,PriceAir,PriceFclAddon*/
    //   variables.exportType = exportType
    //   variables.currency = currency
    //   variables.data = xml
    //   variables.fileName = fileName
    //   variables.splitIndex = splitIndex
    //   variables.sessonId = Session.getInstance().getCurrentSessionId()
    //   exportToExcelByURLVariables(variables, fileName, "ExcelService")
    // }
    // return 0
  }
  /**
   * 把字符对象导出成Excel
   * @param s
   */
  static exportToExcel(s, fileName, footer = null) {
    // var variables: URLVariables = new URLVariables()
    // variables.data = s
    // if (footer)
    //   variables.footer = footer
    // if (fileName)
    //   variables.fileName = fileName
    // exportToExcelByURLVariables(variables, fileName)
  }
  static exportExportToExcel(reportName, conditionXML, dataXML) {
    // var variables: URLVariables = new URLVariables()
    // if (conditionXML) {
    //   variables.conditionData = conditionXML
    // }
    // variables.data = dataXML
    // variables.reportName = reportName
    // exportReportToExcelByURLVareables(variables, reportName)
  }
  /**
   * 根据JobNo查询数据库导出Excel
   * @param s
   */
  static exportToExcelByJobNo(jobType, carrier, jobNo, isMasterJob, fileName) {
    // var variables: URLVariables = new URLVariables()
    // variables.type = jobType
    // variables.currentOffice = Session.getInstance().currentOffice.code
    // variables.carrier = carrier
    // variables.isMasterJob = isMasterJob
    // variables.data = jobNo
    // variables.fileName = fileName
    // variables.sessonId = Session.getInstance().getCurrentSessionId()
    // exportToExcelByURLVariables(variables, fileName, "ExcelService")
  }
  /**
   * 财务综合查询报表导出
   * fileName:
   * conditions:
   * columns:
   * datas:
   */
  static exportReportExcel(fileName, conditions, columns, datasCollection) {
    // var conditionXML = transformConditionsToXML(conditions)
    // var dataXML = transformDatasToXML(columns, datas)
    // var state = 0
    // if (dataXML.children().length() == 1) {
    //   state = datas.length > 0 ? 1 : 2
    // }
    // else {
    //   exportExportToExcel(fileName, conditionXML, dataXML)
    // }
    // return state
  }
  static exportToExcelByURLVariables(variables, fileName, serviceName = 'ExportExcelService') {
    // var serverUrl = ServerConfig.getChannel("my-amf").endpoint
    // serverUrl = serverUrl.slice(0, -17)
    // if (StrUtils.isEmpty(fileName)) {
    //   serverUrl += serviceName
    // } else {
    //   serverUrl += serviceName + "?fileName=" + encodeURIComponent(fileName)
    // }
    // var request: URLRequest = new URLRequest(serverUrl)
    // request.contentType = "application/x-www-form-urlencodedcharset=UTF8"
    // request.method = URLRequestMethod.POST
    // request.data = variables
    // navigateToURL(request, "_blank")
  }
  static exportReportToExcelByURLVareables(variables, fileName) {
    // var serviceName = "ExportReportExcelService"
    // var serverURL = ServerConfig.getChannel("my-amf").endpoint
    // serverURL = serverURL.slice(0, -17)
    // serverURL += serviceName
    // var request: URLRequest = new URLRequest(serverURL)
    // request.contentType = "application/x-www-form-urlencodedcharset=UTF8"
    // request.method = URLRequestMethod.POST
    // request.data = variables
    // navigateToURL(request, "_blank")
  }
  /**
   * 把字符对象导出成Pdf
   * @param s
   */
  static exportToPdf(s, fileName) {
    // var serverUrl = ServerConfig.getChannel("my-amf").endpoint
    // serverUrl = serverUrl.slice(0, -17) + "PdfService"
    // var request: URLRequest = new URLRequest(serverUrl)
    // request.contentType = "application/x-www-form-urlencodedcharset=UTF8"
    // request.method = URLRequestMethod.POST
    // var variables: URLVariables = new URLVariables()
    // variables.data = s
    // request.data = variables
    // navigateToURL(request, "_blank")
  }
  /**
   * 创建表头
   */
  static createHeader(list, columns, columnNames = null) {
    //     var frow = <row />
    //     var fitem = null
    //     var header: *=null
    //     if (columnNames == null) {
    //       for each(header in columns)
    // 				{
    //           //we don't export unvisible column
    //           if( !header.visible || header.dataField == null || StringUtil.trim(header.dataField).length == 0)
    //           continue
    //           if(header.dataField == "isSelect" && list.length > 0 && list.getItemAt(0) is ISelectable)
    //           continue
    //           if(header.dataField == "isSelect")
    //           continue
    //           fitem = <item />
    //           fitem.@type = TYPE_STRING
    //       fitem.@width = parseInt(header.width) < 160 ? parseInt(header.width) : 160
    //       fitem.setChildren(header.headerText)
    //       frow.appendChild(fitem)
    //     }
    //   }
    //   else
    // 			{
    //   //给定了列头
    //   var len = columns.length
    //   for (var i = 0 i < len i++) {
    //     header = columns[i]
    //     //we don't export unvisible column
    //     if (header.dataField == null || StringUtil.trim(header.dataField).length == 0)
    //       continue
    //     if (header.dataField == "isSelect" && list.length > 0 && list.getItemAt(0) is ISelectable)
    //     continue
    //     fitem = <item />
    //     fitem.@type = TYPE_STRING
    //     fitem.@width = parseInt(header.width) < 160 ? parseInt(header.width) : 160
    //     fitem.setChildren(columnNames[i])
    //     frow.appendChild(fitem)
    //   }
    // }
    // return frow
  }
  /**
   * 创建报表的数据表头
   */
  static createReportHeader(columns, datasCollection) {
    //     var frow = <row />
    //     var fitem = null
    //     var header: *=null
    //     for each(header in columns)
    // 			{
    //         if(!header.visible || header.dataField == null || StringUtil.trim(header.dataField).length == 0)
    //         continue
    //       fitem = <item />
    //       fitem.@width = parseInt(header.width) < 160 ? parseInt(header.width) : 160
    //     fitem.setChildren(header.headerText)
    //     frow.appendChild(fitem)
    //   }
    // return frow
  }
  /**
   * 是否需要选择所有
   */
  static needAutoAll(list) {
    // var all = false
    // if (list.length > 0 && list.getItemAt(0) is ISelectable)
    // {
    //   var count = 0
    //   for each(var obj in list)
    //   {
    //     if (obj is ISelectable && ISelectable(obj).isSelect)
    //     {
    //       count++
    //     }
    //   }
    //   all = count == 0
    // }
    // return all
  }
  /**
   * 组织查询条件xml
   */
  static transformConditionsToXML(conditions) {
    // if (conditions && conditions.length > 0) {
    //   var conditionSymbol = { "Like": "包含", "=": "等于", "!=": "不等于" }
    //   var conditionsXML = <conditions />
    //   for each(var obj in conditions)
    //   {
    //     var conditionXML = <condition />
    //     var dataType = obj["fieldType"] as String
    //     if (dataType.indexOf("date") > -1) {
    //       conditionXML.@type = "date"
    //     }
    //     else {
    //       conditionXML.@type = dataType
    //     }
    //     if (dataType.indexOf("dateRange") > -1) {
    //       conditionXML.@startDate = obj.value.start
    //       conditionXML.@endDate = obj.value.end
    //       conditionXML.@operator = "至"
    //     }
    //     else {
    //       conditionXML.@operator = conditionSymbol[obj.operator]
    //       conditionXML.@value = obj.value
    //     }
    //     conditionXML.setChildren(obj.fieldLabel)
    //     conditionsXML.appendChild(conditionXML)
    //   }
    // }
    // return conditionsXML
  }
  /**
   * 组织查询的数据xml
   */
  static transformDatasToXML(columns, datasCollection) {
    // var table = <table />
    // table.appendChild(createReportHeader(columns, datas))
    // for each(var obj in datas)
    // {
    //   var row = <row />
    //   for each(var column: * in columns)
    //   {
    //     if (!column.visible)
    //       continue
    //     if (column.dataField == null || StringUtil.trim(column.dataField).length == 0)
    //       continue
    //     var dataField = column.dataField
    //     var num: Number
    //     var data: *
    //     if (column.labelFunction != null) {
    //       data = column.labelFunction(obj, column)
    //     }
    //     else if (obj.hasOwnProperty(dataField)) {
    //       data = obj[dataField]
    //     }
    //     var item = <item />
    //     if (column.decimalDigits != 0) {
    //       item.@type = "double"
    //     }
    //     else {
    //       item.@type = "text"
    //     }
    //     item.@width = parseInt(column.width)
    //     item.setChildren(data)
    //     row.appendChild(item)
    //   }
    //   table.appendChild(row)
    // }
    // return table
  }
  /**
   * 把表格数据源转换成XML
   * @param s
   * @param list
   * @param columns
   * @param exportVisible 只导出界面上可见的列
   * @reurn xml
   */
  static transformGridDataToXML(list, columns, exportType = 0, columnNames = null, converNumber = true, converDateToStandard = true) {
    // var table = <table />
    // table.appendChild(createHeader(list, columns, columnNames))
    // var all = needAutoAll(list)
    // for each(var obj in list)
    // {
    //   if (((obj is ISelectable && !ISelectable(obj).isSelect)
    //                     || (obj.hasOwnProperty("isSelect") && !obj.isSelect)) && !all)
    //   continue
    //   var row = <row />
    //   for each(var column: * in columns)
    //   {
    //     if (exportType == 0 && !column.visible)
    //       continue
    //     if (column.dataField == null || StringUtil.trim(column.dataField).length == 0)
    //       continue
    //     if (column.dataField == "isSelect" && obj is ISelectable)
    //     continue
    //     if (column.dataField == "isSelect")
    //       continue
    //     var dataField = column.dataField
    //     var num: Number
    //     var data: *
    //     if (dataField.indexOf(".") != -1) {
    //       var complexNames = dataField.split(".")
    //       var currentRef = obj
    //       if (complexNames && currentRef) {
    //         for (var i = 0 i < complexNames.length i++) {
    //           if (currentRef && currentRef.hasOwnProperty(complexNames[i])) {
    //             currentRef = currentRef[complexNames[i]]
    //           }
    //         }
    //       }
    //       data = currentRef
    //     }
    //     else if (column.labelFunction != null) {
    //       data = column.labelFunction(obj, column)
    //       if (data != null && !StrUtils.isEmpty(data.toString()) && obj.hasOwnProperty(dataField) && converNumber) {
    //         if (!StrUtils.isChinese(data) && !StrUtils.isEnglish(data)) {
    //           //去掉千位分隔符
    //           var dataStr = data.toString()
    //           var myPattern: RegExp = /,/g
    //           dataStr = dataStr.replace(myPattern, "")
    //           if (!isNaN(Number(dataStr))) {
    //             data = Number(dataStr)
    //           }
    //           //								else
    //           //								{
    //           //									data = obj[dataField]
    //           //								}
    //         }
    //       }
    //     }
    //     else if (obj.hasOwnProperty(dataField)) {
    //       data = StrUtils.replaceSpecialCharacter(obj[dataField])
    //     }
    //     else {
    //       data = ""
    //     }
    //     var type = checkType(data)
    //     var item = <item />
    //     item.@width = (type == TYPE_FLOAT) ? parseInt(column.width) * 1.8 : parseInt(column.width)
    //     item.@type = type
    //     if (type == TYPE_DATE) {
    //       var d: Date = data as Date
    //       if (d) {
    //         if (converDateToStandard) {
    //           item.setChildren(DateUtils.formatStandardDate(d))
    //         } else {
    //           item.setChildren(DateUtils.formatStandardDateMinutes(d))
    //         }
    //       }
    //     }
    //     else if (data != null) {
    //       item.setChildren(data)
    //     }
    //     row.appendChild(item)
    //   }
    //   table.appendChild(row)
    // }
    // return table
  }
  /**
   * 把表格数据源转换成XML(环海专用)
   * @param s
   * @param list
   * @param columns
   * @param exportVisible 只导出界面上可见的列
   * @reurn xml
   */
  static transformGridDataToXMLByHuanHai(list, columns, exportType = 0, columnNames = null, converNumber = true, converDateToStandard = true) {
    // var table = <table />
    // table.appendChild(createHeader(list, columns, columnNames))
    // var all = needAutoAll(list)
    // for each(var obj in list)
    // {
    //   if (((obj is ISelectable && !ISelectable(obj).isSelect)
    // 			|| (obj.hasOwnProperty("isSelect") && !obj.isSelect)) && !all)
    //   continue
    //   var row = <row />
    //   for each(var column: * in columns)
    //   {
    //     if (exportType == 0 && !column.visible)
    //       continue
    //     if (column.dataField == null || StringUtil.trim(column.dataField).length == 0)
    //       continue
    //     if (column.dataField == "isSelect" && obj is ISelectable)
    //     continue
    //     if (column.dataField == "isSelect")
    //       continue
    //     var dataField = column.dataField
    //     var num: Number
    //     var data: *
    //     if (dataField.indexOf(".") != -1) {
    //       var complexNames = dataField.split(".")
    //       var currentRef = obj
    //       if (complexNames && currentRef) {
    //         for (var i = 0 i < complexNames.length i++) {
    //           if (currentRef && currentRef.hasOwnProperty(complexNames[i])) {
    //             currentRef = currentRef[complexNames[i]]
    //           }
    //         }
    //       }
    //       data = currentRef
    //     }
    //     else if (column.labelFunction != null) {
    //       data = column.labelFunction(obj, column)
    //       if (data != null && !StrUtils.isEmpty(data.toString()) && obj.hasOwnProperty(dataField) && converNumber) {
    //         if (!StrUtils.isChinese(data) && !StrUtils.isEnglish(data)) {
    //           //去掉千位分隔符
    //           var dataStr = data.toString()
    //           var myPattern: RegExp = /,/g
    //           dataStr = dataStr.replace(myPattern, "")
    //           if (!isNaN(Number(dataStr))) {
    //             data = Number(dataStr)
    //           }
    //         }
    //       }
    //     }
    //     else if (obj.hasOwnProperty(dataField)) {
    //       data = obj[dataField]
    //       if (data == 0) {
    //         data = ""
    //       }
    //     }
    //     else {
    //       data = ""
    //     }
    //     var type = checkType(data)
    //     var item = <item />
    //     item.@width = (type == TYPE_FLOAT) ? parseInt(column.width) * 1.8 : parseInt(column.width)
    //     item.@type = type
    //     if (type == TYPE_DATE) {
    //       var d: Date = data as Date
    //       if (d) {
    //         if (converDateToStandard) {
    //           item.setChildren(DateUtils.formatStandardDate(d))
    //         } else {
    //           item.setChildren(DateUtils.formatStandardDateMinutes(d))
    //         }
    //       }
    //     }
    //     else if (data != null) {
    //       item.setChildren(data)
    //     }
    //     row.appendChild(item)
    //   }
    //   table.appendChild(row)
    // }
    // return table
  }
  /**
   * 把表格数据源转换成XML
   * @param s
   * @param list
   * @param columns
   * @param startRow 此行上面的所有行用于显示公共属性
   * @param selectedAll 表格是否显示了勾选框，若没有显示，则导出全部数据
   * @reurn xml
   */
  static transformGridDataToExcel(list, columns, startRow = 0, selectedAll = false) {
    // if (list.length == 0)
    //   return null
    // var enableColumns = []
    // for each(var header: * in columns)
    // {
    //   if (!header.visible || header.dataField == null || StringUtil.trim(header.dataField).length == 0)
    //     continue
    //   if (header.dataField == "isSelect")
    //     continue
    //   enableColumns.push(header)
    // }
    // var availableRows = null
    // if (selectedAll) {
    //   availableRows = list.toArray()
    // }
    // else {
    //   availableRows = []
    //   for each(var item in list)
    //   {
    //     if (item.isSelect) {
    //       availableRows.push(item)
    //     }
    //   }
    // }
    // if (availableRows.length == 0)
    //   return null
    // var sheet: Sheet = new Sheet()
    // sheet.resize(availableRows.length + 1 + startRow, enableColumns.length)
    // sheet.name = "Sheet1"
    // var i = 0
    // var column: *
    // // set titles
    // for (i i < enableColumns.length i++) {
    //   column = enableColumns[i]
    //   sheet.setCell(startRow, i, column.headerText)
    // }
    // // write data
    // var len = availableRows.length + startRow
    // for (i = startRow i < len i++) {
    //   var row = availableRows[i - startRow]
    //   for (var j = 0 j < enableColumns.length j++) {
    //     column = enableColumns[j]
    //     var value: * = null
    //     //					var type:String = checkType(value)
    //     if (column.labelFunction != null) {
    //       value = column.labelFunction(row, column)
    //     }
    //     else if (row.hasOwnProperty(column.dataField)) {
    //       value = row[column.dataField]
    //     }
    //     if (!value) {
    //       value = ""
    //     }
    //     //Excel 超过10位会自动科学计数、超过15位尾数丢失，以下防止类似情况发生
    //     if (!isNaN(Number(value)) && String(value).length > 10)
    //       value = '\'' + value
    //     sheet.setCell(i + 1, j, value)
    //   }
    // }
    // var excel: ExcelFile = new ExcelFile()
    // excel.sheets.addItem(sheet)
    // return excel
  }
  /**
   * 用后台导出excel
   */
  static exportExcelJava(list, columns, fileName, footer = null, converNumber = true) {
    // var state = 0
    // var xml = transformGridDataToXML(list, columns, 0, null, converNumber)
    // if (xml.children().length() == 1) {
    //   state = list.length > 0 ? 1 : 2
    // }
    // else {
    //   exportToExcel(xml.toXMLString(), fileName, footer)
    // }
    // return state
  }
  /**
   * 用后台导出excel(环海专用)
   */
  static exportExcelJavaByHuanHai(list, columns, fileName, footer = null, converNumber = true) {
    // var state = 0
    // var xml = transformGridDataToXMLByHuanHai(list, columns, 0, null, converNumber)
    // if (xml.children().length() == 1) {
    //   state = list.length > 0 ? 1 : 2
    // }
    // else {
    //   exportToExcel(xml.toXMLString(), fileName, footer)
    // }
    // return state
  }
  /**
   * 导出Excel数据并保存
   * return 0:成功 1:有数据但是没有选择 2:没有数据
   */
  static exportExcel(list, columns, fileName = null, selectedAll = false) {
    // return exportExcel2(list, columns, null, null, fileName, selectedAll)
  }
  /**
   * 在表格的前几行插入一些公共的属性
   */
  static exportExcel2(list, columns, commonFields, commonValues, fileName = null, selectedAll = false) {
    // var state = 0
    // var startRow = commonFields == null ? 0 : commonFields.length + 1
    // var excel: ExcelFile = transformGridDataToExcel(list, columns, startRow, selectedAll)
    // if (excel == null) {
    //   state = list.length > 0 ? 1 : 2
    // }
    // else {
    //   try {
    //     if (commonFields) {
    //       var sheet: Sheet = excel.sheets.getItemAt(0) as Sheet
    //       for (var i = 0 i < commonFields.length i++) {
    //         sheet.setCell(i, 0, commonFields[i])
    //         sheet.setCell(i, 1, commonValues[i])
    //       }
    //     }
    //     var fileStream: ByteArray = null
    //     if (ResourceManager.getInstance().localeChain[0] == "zh_CN") {
    //       fileStream = excel.saveToByteArray("GBK")
    //     }
    //     else {
    //       fileStream = excel.saveToByteArray("iso8859-1")
    //     }
    //     var file: FileReference = new FileReference()
    //     file.addEventListener(IOErrorEvent.IO_ERROR, ioErrorHandler)
    //     file.addEventListener(SecurityErrorEvent.SECURITY_ERROR, securityErrorHandler)
    //     var d: Date = new Date()
    //     if (!fileName) {
    //       fileName = "Export " + d.fullYear + (d.month + 1) + d.date + d.hours + d.minutes + d.seconds + ".xls"
    //     }
    //     file.save(fileStream, fileName)
    //     excel = null
    //   }
    //   catch (error: Error) {
    //     Alert.show(ResourceManager.getInstance().getString(BUNDLE_NAME, "FileSaveFailed"), ResourceManager.getInstance().getString(BUNDLE_NAME, "Error"))
    //   }
    // }
    // return state
  }
  /**
   * AdvancedDataGrid导出Excel数据
   * return 0:成功 1:有数据但是没有选择 2:没有数据
   */
  static exportExcelADV(dataProvider, columns, fileName = null) {
    // var state
    // if (dataProvider is IList)
    // {
    //   state = exportExcel(dataProvider as IList, columns, fileName)
    // }
    // 	else if (dataProvider is IHierarchicalCollectionView)
    // {
    //   var list = convertHierarchical(dataProvider as HierarchicalCollectionView)
    //   state = list.length == 0 ? 1 : exportExcel(list, columns, fileName)
    // }
    // return state
  }
  /**
   * 在表格的前几行插入一些公共的属性
   */
  static exportExcelADV2(dataProvider, columns, commonFields, commonValues, fileName = null, selectedAll = false) {
    // var state
    // if (dataProvider is IList)
    // {
    //   state = exportExcel2(dataProvider as IList, columns, commonFields, commonValues, fileName, selectedAll)
    // }
    // 	else if (dataProvider is IHierarchicalCollectionView)
    // {
    //   var list = convertHierarchical(dataProvider as HierarchicalCollectionView)
    //   state = list.length == 0 ? 1 : exportExcel2(list, columns, commonFields, commonValues, fileName, selectedAll)
    // }
    // return state
  }
  /**
   * 从java导出AdvancedDataGrid数据
   * return 0:成功 1:有数据但是没有选择 2:没有数据
   */
  static exportExcelADVJava(dataProvider, columns, fileName = null) {
    // var state = 0
    // if (dataProvider is IList)
    // {
    //   state = exportExcelJava(dataProvider as IList, columns, fileName)
    // }
    // 	else if (dataProvider is IHierarchicalCollectionView)
    // {
    //   var list = convertHierarchical(dataProvider as HierarchicalCollectionView)
    //   state = exportExcelJava(list, columns, fileName)
    // }
    // return state
  }
  /**
   * 从java导出AdvancedDataGrid数据-导出全部
   * return 0:成功 1:有数据但是没有选择 2:没有数据
   */
  static exportExcelADVJava2(dataProvider, columns, fileName = null) {
    // var state = 0
    // if (dataProvider is IList)
    // {
    //   for each(var obj in dataProvider)
    //   {
    //     if (obj.hasOwnProperty("isSelect") && obj.isSelect) {
    //       obj.isSelect = false
    //     }
    //   }
    //   state = exportExcelJava(dataProvider as IList, columns, fileName)
    // }
    // 	else if (dataProvider is IHierarchicalCollectionView)
    // {
    //   var list = convertHierarchical(dataProvider as HierarchicalCollectionView)
    //   state = exportExcelJava(list, columns, fileName)
    // }
    // return state
  }
  /**
   * 导出PDF
   * return 0:成功 1:有数据但是没有选择 2:没有数据
   */
  static exportPdf(list, columns, fileName = null) {
    // var state = 0
    // var xml = transformGridDataToXML(list, columns)
    // if (xml.children().length() == 1) {
    //   state = list.length > 0 ? 1 : 2
    // }
    // else {
    //   ExportUtils.exportToPdf(xml, fileName)
    // }
    // return state
  }
  /**
   * AdvancedDataGrid导出PDF数据
   * return 0:成功 1:有数据但是没有选择 2:没有数据
   */
  static exportPdfADV(dataProvider, columns, fileName = null) {
    // var state = 0
    // if (dataProvider is IList)
    // {
    //   state = exportPdf(dataProvider as IList, columns, fileName)
    // }
    // 	else if (dataProvider is IHierarchicalCollectionView)
    // {
    //   var list = convertHierarchical(dataProvider as HierarchicalCollectionView)
    //   state = exportPdf(list, columns, fileName)
    // }
    // return state
  }
  /**
   * 获取IList类型的对象
   * @param dataProvider
   * @return
   */
  static getIListObject(dataProvider) {
    // var list = new ArrayCollection()
    // if (dataProvider is IList)
    // {
    //   list = dataProvider as IList
    // }
    //         else if (dataProvider is IHierarchicalCollectionView)
    // {
    //   list = ExportUtils.convertHierarchical(dataProvider as HierarchicalCollectionView)
    // }
    // return list
  }
  /**
   * 把层级数据转换成简单集合
   */
  static convertHierarchical(hierarchicalCollectionView) {
    //     var hierarhcical: HierarchicalData = hierarchicalCollectionView.source as HierarchicalData
    //     var listCollection = new ArrayCollection()
    //     if (hierarhcical.source && hierarhcical.source.length > 0) {
    //       var item = hierarhcical.source[0]
    //       if (item is IListItemData)
    //       {
    //         for each(item in hierarhcical.source)
    // 					{
    //             if(item.isSelect) {
    //             list.addItem(item)
    //           }
    // 						checkChildren(list, item)
    //       }
    //     }
    //     else {
    //       for each(item in hierarhcical.source)
    // 					{
    //           addItem(item, list)
    //         }
    // 				}
    //   }
    // return list
  }
  /**
   * 递归算法，循环遍历所有子集
   */
  static checkChildren(listCollection, item) {
    // if (item.children != null && item.children.length > 0) {
    //   for each( var node in item.children )
    //   {
    //     if (node.isSelect) {
    //       list.addItem(node)
    //     }
    //     if (node.children) {
    //       checkChildren(list, node)
    //     }
    //   }
    // }
    // else {
    //   checkChildren2(list, item as Object)
    // }
  }
  /**
   * 递归算法，循环遍历所有子集
   */
  static checkChildren2(listCollection, oldItem) {
    // if (oldItem.hasOwnProperty("children2")) {
    //   if (!oldItem.children2) return
    //   for each( var node in oldItem.children2 )
    //   {
    //     if (node.isSelect) {
    //       list.addItem(node)
    //       if (node.hasOwnProperty("children2") && node.children2 && node.children2.length > 0) {
    //         checkChildren(list, node as IListItemData)
    //       }
    //     }
    //   }
    // }
  }
  static addItem(item, listCollection) {
    // list.addItem(item)
    // if (item.hasOwnProperty("children")) {
    //   for each(var sonItem in item.children)
    //   {
    //     addItem(sonItem, list)
    //   }
    // }
  }
  static ioErrorHandler(event) {
    // if (event.errorID == 2038) {
    //   Alert.show(ResourceManager.getInstance().getString(BUNDLE_NAME, 'FileOpened'), ResourceManager.getInstance().getString(BUNDLE_NAME, 'Error'))
    // } else {
    //   Alert.show(ResourceManager.getInstance().getString(BUNDLE_NAME, 'FileSaveFailed'), ResourceManager.getInstance().getString(BUNDLE_NAME, 'Error'))
    // }
  }
  static securityErrorHandler(event) {
    // Alert.show(ResourceManager.getInstance().getString(BUNDLE_NAME, 'SecurityError'), ResourceManager.getInstance().getString(BUNDLE_NAME, 'Error'))
  }
}
